import { render, staticRenderFns } from "./TermOfService.vue?vue&type=template&id=2801f5f3"
import script from "./TermOfService.vue?vue&type=script&lang=js"
export * from "./TermOfService.vue?vue&type=script&lang=js"
import style0 from "./TermOfService.vue?vue&type=style&index=0&id=2801f5f3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports